import { render, staticRenderFns } from "./InvoiceJournalReport.vue?vue&type=template&id=b1fdd05e&scoped=true&"
import script from "./InvoiceJournalReport.vue?vue&type=script&lang=js&"
export * from "./InvoiceJournalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fdd05e",
  null
  
)

export default component.exports